import { getEnumObject } from '../utilities.js';

export const colors = {
  GREEN: 'green',
  RED: 'red',
  YELLOW: 'yellow',
};

export default getEnumObject(colors);
